export const POLYGON_PATH_MOROWALI = [
  { lat: -2.7172614797006247, lng: 122.02977908778342 },
  { lat: -2.71990347249087, lng: 122.02795497082866 },
  { lat: -2.72305158660987, lng: 122.03267740694673 },
  { lat: -2.7205614391432817, lng: 122.03441031805511 },
  { lat: -2.717271602289358, lng: 122.02977908778342 }
]

export const POLYGON_PATH_ADANGBAY = [
  { lat: -1.7, lng: 116.636111 },
  { lat: -1.7, lng: 116.658333 },
  { lat: -1.727778, lng: 116.658333 },
  { lat: -1.727778, lng: 116.636111 }
]

export const POLYGON_OPTIONS = {
  fillColor: '#003399',
  fillOpacity: 0,
  strokeColor: '#003399',
  strokeOpacity: 1,
  strokeWeight: 2,
  strokeDashArray: [6, 6]
}
